import dynamic from 'next/dynamic';
const Layout = dynamic(() => import('../hoc/staticLayout'), { loading: () => <></>, ssr: true });
const ContactContent = dynamic(() => import('../components/static/contactPage'), { loading: () => <></>, ssr: true });
import { withRouter } from 'next/router';
import { getContactPageData } from "../api/contact";

function Contact(props) {
	const meta = {
		title: "Contact Bayan | Contact Bayan Chicago | Contact Chicago Theological Seminary",
		description: "As of Fall 2019, Bayan operates its degree programs at Chicago Theological Seminary (CTS), located in the Hyde Park area near the University of Chicago.",
		route: "contact",
	}
	return (
		<>
			<Layout theme={props.theme} meta={meta}>
				<ContactContent router={props.router} contactPageData={props?.contactPageData} />
			</Layout>
		</>
	);
}

export async function getServerSideProps(ctx) {
	const contactPageData = await getContactPageData();
	// console.log(contactPageData);
	return { props: { contactPageData: contactPageData } }
}
export default withRouter(Contact);
